export default {
    ADMIN: 1,
    USER: 2,
    SUB_ADMIN:3
};
